import { useCallback } from "react";
import { readConnectorServerAddress } from "../../api/connectorsApi";
import { useLoad } from "../../shared/loading/useLoad";

/** The address connectors pair with, for the commands this page shows; `not_configured` until an administrator sets it. */
export type ConnectorServerAddress =
  | { readonly kind: "loading" }
  | { readonly kind: "not_configured" }
  | { readonly kind: "known"; readonly address: string };

/**
 * The address as the server reports it (`threads.connector_hub.public_origin`). App and API share
 * that one origin (Q-35, Q-65); if it can't be read, this page's origin is the best guess.
 */
export function useConnectorServerAddress(): ConnectorServerAddress {
  const load = useCallback((signal: AbortSignal) => readConnectorServerAddress(signal), []);
  const { state } = useLoad(load);
  if (state.status === "loading") return { kind: "loading" };
  if (state.status === "loaded" && state.value === null) return { kind: "not_configured" };
  return { kind: "known", address: state.status === "loaded" && state.value !== null ? state.value : window.location.origin };
}
